<template>
  <div>
      <wordcloud
        :data="wordsData"
        nameKey="name"
        valueKey="g2"
        :color="wordcloudOptions.color"
        :fontSize="wordcloudOptions.fontSize"
        :font="wordcloudOptions.font"
        :showTooltip="wordcloudOptions.showTooltip"
        :wordClick="wordClickHandler">
      </wordcloud>

      <v-data-table
          :headers="tableHeaders"
          :items="wordsData"
          :items-per-page="10"
          class="elevation-1"
      ></v-data-table>

      <div class="text-center">
        <div>
          <v-btn @click="downloadString" class="ma-2" color="green darken-2" dark><v-icon dark left>mdi-file-download-outline</v-icon>Download Data</v-btn>
        </div>
      </div>
  </div>
</template>

<script>
import wordcloud from 'vue-wordcloud'
import { helper } from '../helper.js';


export default {
  name: 'RelationGraph',
  components: {
    wordcloud
  },
  props: [ "g2Values", "showWordcloudAction" ],
  methods: {
    wordClickHandler(name, value, vm) {
      console.log('wordClickHandler', name, value, vm);
    },
    downloadString( ){
      let header = this.tableHeaders.map( e => e.text )
      let headerStr = header.join("\t") + "\n"
      let body = this.wordsData.map( e=> [ e.name, e.g2, e.pvalue, e.group].join("\t") )
      let bodyStr = body.join("\n")
      console.log( "Downloading .... ")
      helper.downloadString( headerStr + bodyStr, "txt/tsv", "data.tsv" )
    }
  },
  computed: {
      wordsData(){
        if( this.showWordcloudAction && this.g2Values ) return this.g2Values
        else return []
      },
      wordcloudOptions(){
          return {
            //   myColors: ['#1f77b4', '#629fc9', '#94bedb', '#c9e0ef']
                color: 'Category10',
                fontSize: [8, 64],
                font: 'impact',
                showTooltip: true
            }
      },
      tableHeaders(){
        if( !this.showWordcloudAction || !this.g2Values ) return []
        return [
            { text: "Term", align: 'start', value: "name" },
            { text: "G2-score", value: "g2" },
            { text: "P-value", value: "pvalue" },
            { text: "Category", value: "group" },
        ]
      }
  },
  data() {
    return {

    }
  }
}

// https://github.com/feifang/vue-wordcloud
</script>

<style>

div.tooltip {
    background: rgba(97,97,97,.9);
    color: #fff;
    border-radius: 4px !important;
    font-size: 14px !important;
    line-height: 22px !important;
    display: inline-block;
    padding: 5px 16px !important;
    position: absolute;
    text-transform: none;
    width: auto !important;
    /* opacity: 1 !important; */
    pointer-events: none;
}

</style>